import { DEFAULT_TEAMS_BY_ROLE, TEAM_IDS } from '../constants/teams';

/**
 * The teams a user is on: what was saved for them, or their role's default when nothing was. The
 * backend's `teamsOf` mirrored, which `backendContract.test.js` checks case by case.
 *
 * @param {{teams?: string[]}|null} membership
 * @param {string|null} role
 * @returns {string[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function teamsOf(membership, role) {
  if (role === 'parent' || !Object.hasOwn(DEFAULT_TEAMS_BY_ROLE, role ?? '')) {
    return [];
  }
  if (Array.isArray(membership?.teams)) {
    return membership.teams.filter((team) => TEAM_IDS.includes(team));
  }

  return DEFAULT_TEAMS_BY_ROLE[role];
} // teamsOf()
